export type EnvironmentConfig = {
  companyContact: string | undefined;
  legalCustomerAgreement: string | undefined;
  profileAction: string;
  idLoginUrl: string;
  hamsUrl: string;
  logoutUrl: () => string;
  marketplaceUrl: string;
  marketplaceV3ProductListingUrl?: string;
  padresUrl: string;
  paypal: {
    env: 'sandbox' | 'production';
  };
  segmentKey: string;
  wacUrl: string;
  wacPurchaseLicensingUrl: string;
  wacLicensingUrl: string;
  i18nUrl: string;
  clicktaleEnabled: boolean;
  cloudMigrationToolsUrl: string;
  statsigClientSDK: string;
  adminHubUrl: string;
  emailMAC: (userEmail: string) => string;
  billingDetailsMAC: string;
  switchUserMAC: string;
  switchAccountMAC: string;
  logOutMAC: string;
  root: string;
  calculatePricingURL: string;
  ppcUrl: string;
  serverIdPageUrl: string;
  support: string;
  bitbucketCmtUrl: string;
  atlAdminUrl: string;
  migrationLink: string;
  intercomAppID?: string;
  omniChannelGraphQLUrl?: string;
  omniChannelFlowId?: string;
  omniChannelEnvironment?: 'staging' | 'production';
};

export const BIZBOX = 'BIZBOX';
export const DEVELOPMENT = 'DEVELOPMENT';
export const E2E = 'E2E';
export const LOCAL = 'LOCAL';
export const PRODUCTION = 'PRODUCTION';
export const STAGING = 'STAGING';

export type Environment = 'BIZBOX' | 'DEVELOPMENT' | 'E2E' | 'LOCAL' | 'PRODUCTION' | 'STAGING';
